// extracted by mini-css-extract-plugin
export default {"vehicle-info":"vehicle-info_vehicle-info__uhZpO","row":"vehicle-info_row__iOrA3","payment-select":"vehicle-info_payment-select__rIdlv"};